// // src/hooks/usePWAInstall.js
// import { useState, useEffect, useCallback } from 'react';

// export function usePWAInstall() {
//   const [deferredPrompt, setDeferredPrompt] = useState(null);
//   const [isInstalled, setIsInstalled] = useState(false);

//   useEffect(() => {
//     const isStandalone =
//       window.matchMedia('(display-mode: standalone)').matches ||
//       window.navigator.standalone === true;
//     if (isStandalone) setIsInstalled(true);

//     const handleBeforeInstall = (e) => {
//       e.preventDefault();
//       setDeferredPrompt(e);
//     };

//     const handleAppInstalled = () => {
//       setIsInstalled(true);
//       setDeferredPrompt(null);
//     };

//     window.addEventListener('beforeinstallprompt', handleBeforeInstall);
//     window.addEventListener('appinstalled', handleAppInstalled);

//     return () => {
//       window.removeEventListener('beforeinstallprompt', handleBeforeInstall);
//       window.removeEventListener('appinstalled', handleAppInstalled);
//     };
//   }, []);

//   const promptInstall = useCallback(async () => {
//     if (!deferredPrompt) return;
//     deferredPrompt.prompt();
//     const { outcome } = await deferredPrompt.userChoice;
//     if (outcome === 'accepted') setIsInstalled(true);
//     setDeferredPrompt(null);
//   }, [deferredPrompt]);

//   const canInstall = !!deferredPrompt && !isInstalled;

//   return { canInstall, promptInstall, isInstalled };
// }


// src/hooks/usePWAInstall.js
import { useState, useEffect } from 'react';

let deferredPromptGlobal = null;

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPromptGlobal = e;
    window.__pwaPrompt = e; // 🐛 pra inspecionar no console
    console.log('🟢 beforeinstallprompt CAPTURADO!');
    window.dispatchEvent(new Event('pwaInstallable'));
  });

  window.addEventListener('appinstalled', () => {
    deferredPromptGlobal = null;
    console.log('🔵 App instalado.');
    window.dispatchEvent(new Event('pwaInstalled'));
  });
}

export function usePWAInstall() {
  const [canInstall, setCanInstall] = useState(!!deferredPromptGlobal);

  useEffect(() => {
    console.log('🔧 usePWAInstall montado. deferredPrompt?', !!deferredPromptGlobal);

    if (deferredPromptGlobal) setCanInstall(true);

    const onInstallable = () => {
      console.log('📩 evento pwaInstallable recebido pelo hook → canInstall = true');
      setCanInstall(true);
    };
    const onInstalled = () => setCanInstall(false);

    window.addEventListener('pwaInstallable', onInstallable);
    window.addEventListener('pwaInstalled', onInstalled);

    return () => {
      window.removeEventListener('pwaInstallable', onInstallable);
      window.removeEventListener('pwaInstalled', onInstalled);
    };
  }, []);

  const promptInstall = async () => {
    if (!deferredPromptGlobal) {
      console.warn('⚠️ Nenhum prompt disponível.');
      return;
    }
    deferredPromptGlobal.prompt();
    const { outcome } = await deferredPromptGlobal.userChoice;
    console.log('📲 Resultado:', outcome);
    deferredPromptGlobal = null;
    setCanInstall(false);
  };

  return { canInstall, promptInstall };
}
